const mediaItems = [
  {
    title: '热门新番速递：《星之妖精》第三季开播',
    desc: '备受期待的《星之妖精》第三季正式上线，全新剧情展开，角色成长令人惊喜。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20fantasy%20manga%20cover%20featuring%20a%20magical%20girl%20with%20starry%20wings%20and%20flowing%20hair%20surrounded%20by%20glowing%20stars%20against%20a%20night%20sky%20background%20with%20soft%20purple%20and%20blue%20gradient%20dreamy%20atmosphere%20detailed%20character%20design%20vibrant%20colors&width=640&height=360&seq=media-card-01&orientation=landscape',
    tag: '新番推荐',
    icon: 'ri-play-circle-line',
  },
  {
    title: '萌系治愈力作《小妖精日常》人气飙升',
    desc: '轻松治愈的日常故事搭配软萌画风，上线两周即登顶萌系分类榜首。',
    img: 'https://readdy.ai/api/search-image?query=Kawaii%20manga%20style%20illustration%20of%20cute%20fairy%20characters%20in%20a%20cozy%20cottage%20setting%20with%20soft%20pastel%20colors%20warm%20sunlight%20streaming%20through%20windows%20adorable%20creatures%20and%20plants%20surrounding%20them%20gentle%20whimsical%20atmosphere%20detailed%20background%20art&width=640&height=360&seq=media-card-02&orientation=landscape',
    tag: '萌系治愈',
    icon: 'ri-heart-line',
  },
  {
    title: '奇幻冒险《魔导师传说》连载突破200话',
    desc: '经典长篇奇幻漫画达成里程碑，作者特别绘制纪念插图回馈读者。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20scene%20with%20a%20powerful%20magician%20casting%20spells%20in%20a%20grand%20ancient%20temple%20dramatic%20lighting%20with%20magical%20energy%20swirling%20around%20detailed%20character%20in%20ornate%20robes%20holding%20a%20glowing%20staff%20cinematic%20composition%20vibrant%20magical%20effects&width=640&height=360&seq=media-card-03&orientation=landscape',
    tag: '奇幻冒险',
    icon: 'ri-sword-line',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精彩推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          最新最热的漫画资讯与精彩内容推荐，不错过任何一部好作品
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600">
                    <i className={item.icon}></i>
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}